import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Step } from "./constants";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { currencyFormatter } from "@/lib/utils";
import { TransferFormValues } from ".";
import { Account, Currency } from "@/lib/types";

const FromAccountStep = ({
  form,
  setStep,
  accounts,
  isPending,
  currencies,
}: {
  form: UseFormReturn<TransferFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  accounts: Account[];
  isPending: boolean;
  currencies: Currency[];
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <DrawerHeader
        title={t("title.select_from_account")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <p className="mx-auto max-w-[200px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.select_from_account")}
      </p>

      {isPending ? (
        <Loading className="mt-10" />
      ) : (
        <div className="mt-5 space-y-[15px]">
          {accounts.map((item, index) => (
            <button
              data-testid={`transfer-form-from-account-item-${item.id}`}
              type="button"
              onClick={() => {
                form.setValue("fromAccountId", item.id);
                setStep(Step.INITAL);
              }}
              key={index}
              className="flex w-full flex-row items-center justify-between rounded-lg bg-[#1FB3CC1F] px-[15px] py-[10px] shadow-[inset_0px_1px_2px_0px_#0C0C2633] backdrop-blur-lg"
            >
              <div className="flex items-center gap-3">
                <img
                  className="h-[40px] w-[55px]"
                  src={
                    item.type === "debit"
                      ? "/images/debit.png"
                      : item.type === "master"
                        ? "/images/mastercard.png"
                        : "/images/visa.png"
                  }
                />

                <div className="flex h-10 flex-col items-start justify-between">
                  <span className="text-[15px] leading-4 text-white">
                    {item.name}
                  </span>
                  <span className="text-[15px] leading-4 text-[#FFFFFFA8]">
                    {item.accountNumber.replace(/^(.{15})/, "**** **** **** ")}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <span className="text-[15px] leading-4 text-white">
                  {currencyFormatter(
                    item.currentBalance,
                    currencies.find(
                      (currency) => currency.id === item.currencyId
                    )?.code ?? ""
                  )}
                </span>
                <CaretRight size={18} color="#E3EDFC" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default FromAccountStep;
